import { fromJS } from 'immutable';
import { objectParameters, numericParameters, boolParameters, shouldSerializeParameter } from '../planParameters';
import { filterMeasurements } from '../generators/shapes';
import { serializeMeasurements } from './serializeMeasurements';
export default function serializePlan(plan, { country, currency, kitchenIslandMeasurements: kitchenIslandMeasurementsI, overhangMeasurements: overhangMeasurementsI, freestandingHobMeasurements, price = '', familyprice = '' } = {}) {
  let parameters = [
    ...objectParameters
      .map((name) => ({
        name,
        value: plan.getIn([name, 'value', 'id']) || 'none',
      })),
    ...numericParameters
      .map((name) => ({
        name,
        value: plan.getIn([name, 'value']).toString() || '0',
      })),
    ...boolParameters
      .map((name) => ({
        name,
        value: plan.get(name).toString(),
      })),
    {
      name: 'shape',
      value: plan.getIn(['plannedShape', 'value', 'id']),
    },
    {
      name: 'kitchenIsland',
      value: plan.getIn(['kitchenIsland', 'value', 'id']),
    },
    {
      name: 'shapeFlipped',
      value: plan.getIn(['plannedShape', 'flipped']).toString(),
    },
    {
      name: 'kitchenIslandFlipped',
      value: plan.getIn(['kitchenIsland', 'flipped']) ? plan.getIn(['kitchenIsland', 'flipped']).toString() : 'false',
    },
    {
      name: 'country',
      value: country,
    },
    {
      name: 'currency',
      value: currency,
    },
    {
      name: 'price',
      value: price.toString().replace('.', ':'),
    },
    {
      name: 'familyPrice',
      value: familyprice ? familyprice.toString().replace('.', ':') : 'false',
    },
    {
      name: 'wallPanelHeight',
      value: () => (plan.getIn(['splashback', 'height']) || plan.getIn(['splashback', 'value', 'defaultHeight'])).toString(),
    },
    {
      name: 'wallPanelStripHeight',
      value: () => (plan.getIn(['wallEdgingStripCustomizable', 'height']) || plan.getIn(['splashback', 'value', 'defaultHeight'])).toString(),
    },
    {
      name: 'kitchenIslandMeasurements',
      value: () => serializeMeasurements(kitchenIslandMeasurementsI),
    },
    {
      name: 'overhangMeasurements',
      value: () => serializeMeasurements(overhangMeasurementsI),
    },
    {
      name: 'freestandingHobMeasurements',
      value: () => {
        const width = fromJS({ width: freestandingHobMeasurements.get('width') });
        return serializeMeasurements(width);
      },
    },
  ];

  const measurements = filterMeasurements(plan.getIn(['plannedShape', 'value', 'dimensions']), plan.getIn(['plannedShape', 'measurements'])).toJS();

  const saveParam = ({ name }) => !shouldSerializeParameter[name] || shouldSerializeParameter[name](plan);
  const lazyEval = (param) => typeof param.value === 'function' ? { ...param, value: param.value(plan) } : param;

  return {
    parameters: parameters
      .filter(saveParam)
      .map(lazyEval),
    measurements,
  };
}
